module.exports = __webpack_public_path__ + "media/loan_payments_calculator/savings_btn-3a7b985f.png";